
import { createSlice } from '@reduxjs/toolkit'
import http from '../http/products'

export const slice = createSlice({
	name: 'counter',
	initialState: {
		products: [],
		selectedCategories: [],
	},
	reducers: {
		setProducts: (state, { payload }) => {
			state.products = payload
		},
		selectCategory: (state, { payload }) => {
			state.selectedCategories = [...new Set(state.selectedCategories.concat(payload))]
		},
		deselectCategory: (state, { payload }) => {
			state.selectedCategories = state.selectedCategories.filter(c => c !== payload)
		},
		deselectAll: state => {
			state.selectedCategories = []
		}
	}
})

export const { setProducts, selectCategory, deselectCategory, deselectAll } = slice.actions

export const fetchProducts = () => async dispatch => {

	let localProducts = localStorage.getItem('temp-products')
	if (localProducts) dispatch(setProducts(JSON.parse(localProducts)))

	let res = await http.fetchProducts()
	if (res.error) return console.log(res.error)

	localStorage.setItem('temp-products', JSON.stringify(res.data))
	dispatch(setProducts(res.data))
};

// Selectors
export const selectProducts = state => {
	return state.products.products
		.filter(p => state.products.selectedCategories.includes(p.title))
		.reduce((products, p) => products.concat(p.data), [])
}
export const selectCategories = state => {
	return state.products.products.map(p => p.title)
}
export const selectSelectedCategories = state => {
	return state.products.selectedCategories
}

export default slice.reducer